import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../actions/index.types';
import * as req from '../../../axios/request/WingsAndFlatsReqs/WingsAndFlatsReq';
import { notify } from '../../../utils/notification';

/* =========================
   WINGS
========================= */

/* GET WINGS LIST */
function* getWingsList(action) {
    try {
        const result = yield call(req.getWingsReq, action);
        if (result.success === true) {
            yield put({
                type: types.SOCIETY_WINGS_LIST_SUCCESS,
                payload: {
                    data: result.data,
                    pagination: result.meta?.pagination || null
                }
            });
        } else {
            yield put({
                type: types.SOCIETY_WINGS_LIST_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_WINGS_LIST_FAILURE,
            message: e?.message
        });
    }
}

/* CREATE WINGS */
function* createWings(action) {
    try {
        const result = yield call(req.createWingsReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.SOCIETY_CREATE_WINGS_SUCCESS,
                payload: result.data
            });
            action?.data?.onSuccess?.();
        } else {
            yield put({
                type: types.SOCIETY_CREATE_WINGS_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_CREATE_WINGS_FAILURE,
            message: e?.message
        });
    }
}

/* EDIT WINGS */
function* editWings(action) {
    try {
        const result = yield call(req.editWingsReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.SOCIETY_EDIT_WINGS_SUCCESS,
                payload: result.data
            });
            action?.data?.onSuccess?.();
        } else {
            yield put({
                type: types.SOCIETY_EDIT_WINGS_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_EDIT_WINGS_FAILURE,
            message: e?.message
        });
    }
}

/* DELETE WINGS */
function* deleteWings(action) {
    try {
        const result = yield call(req.deleteWingsReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.SOCIETY_DELETE_WINGS_SUCCESS,
                payload: result.data
            });
            action?.data?.onSuccess?.();
        } else {
            yield put({
                type: types.SOCIETY_DELETE_WINGS_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_DELETE_WINGS_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   FLATS
========================= */

/* GET FLATS LIST */
function* getFlatsList(action) {
    try {
        const result = yield call(req.getFlatsReq, action);
        if (result.success === true) {
            yield put({
                type: types.SOCIETY_FLATS_LIST_SUCCESS,
                payload: {
                    data: result.data,
                    pagination: result.meta?.pagination || null,
                    stats: result.meta?.stats || null
                }
            });
        } else {
            yield put({
                type: types.SOCIETY_FLATS_LIST_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_FLATS_LIST_FAILURE,
            message: e?.message
        });
    }
}

/* CREATE FLATS */
function* createFlats(action) {
    try {
        const result = yield call(req.createFlatReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.SOCIETY_CREATE_FLATS_SUCCESS,
                payload: result.data
            });
            action?.data?.onSuccess?.();
        } else {
            yield put({
                type: types.SOCIETY_CREATE_FLATS_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_CREATE_FLATS_FAILURE,
            message: e?.message
        });
    }
}

/* EDIT FLATS */
function* editFlats(action) {
    try {
        const result = yield call(req.editFlatReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.SOCIETY_EDIT_FLATS_SUCCESS,
                payload: result.data
            });
            action?.data?.onSuccess?.();
        } else {
            yield put({
                type: types.SOCIETY_EDIT_FLATS_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_EDIT_FLATS_FAILURE,
            message: e?.message
        });
    }
}

/* DELETE FLATS */
function* deleteFlats(action) {
    try {
        const result = yield call(req.deleteFlatReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({
                type: types.SOCIETY_DELETE_FLATS_SUCCESS,
                payload: result.data
            });
            action?.data?.onSuccess?.();
        } else {
            yield put({
                type: types.SOCIETY_DELETE_FLATS_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_DELETE_FLATS_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   WINGS DROPDOWN
========================= */
function* getWingsDropdown(action) {
    try {
        const result = yield call(req.getWingsDropdownReq, action);
        if (result.success === true) {
            yield put({
                type: types.SOCIETY_WINGS_DROPDOWN_SUCCESS,
                payload: result.data
            });
        } else {
            yield put({
                type: types.SOCIETY_WINGS_DROPDOWN_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_WINGS_DROPDOWN_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   FLATS DROPDOWN
========================= */
function* getFlatsDropdown(action) {
    try {
        const result = yield call(req.getFlatsDropdownReq, action);
        if (result.success === true) {
            yield put({
                type: types.SOCIETY_FLATS_DROPDOWN_SUCCESS,
                payload: result.data
            });
        } else {
            yield put({
                type: types.SOCIETY_FLATS_DROPDOWN_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_FLATS_DROPDOWN_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   FLATS WITH OWNERSHIP
========================= */
function* getFlatsWithOwnership(action) {
    try {
        const result = yield call(req.getFlatsWithOwnershipReq, action);
        if (result.success === true) {
            yield put({
                type: types.SOCIETY_FLATS_WITH_OWNERSHIP_SUCCESS,
                payload: result.data
            });
        } else {
            yield put({
                type: types.SOCIETY_FLATS_WITH_OWNERSHIP_FAILURE,
                message: result?.message
            });
        }
    } catch (e) {
        console.log(e);
        yield put({
            type: types.SOCIETY_FLATS_WITH_OWNERSHIP_FAILURE,
            message: e?.message
        });
    }
}

/* =========================
   BULK UPLOAD — WINGS / FLATS
========================= */
function* bulkUploadWings(action) {
    try {
        const result = yield call(req.bulkUploadWingsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_BULK_UPLOAD_WINGS_SUCCESS, payload: result });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_BULK_UPLOAD_WINGS_FAILURE, message: result?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_BULK_UPLOAD_WINGS_FAILURE, message: e?.message });
    }
}

function* bulkUploadFlats(action) {
    try {
        const result = yield call(req.bulkUploadFlatsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_BULK_UPLOAD_FLATS_SUCCESS, payload: result });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_BULK_UPLOAD_FLATS_FAILURE, message: result?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_BULK_UPLOAD_FLATS_FAILURE, message: e?.message });
    }
}

/* =========================
   ROOT SOCIETY SAGA
========================= */
export default function* WingsAndFlatsSaga() {
    // Wings
    yield takeLatest(types.SOCIETY_WINGS_LIST, getWingsList);
    yield takeLatest(types.SOCIETY_CREATE_WINGS, createWings);
    yield takeLatest(types.SOCIETY_EDIT_WINGS, editWings);
    yield takeLatest(types.SOCIETY_DELETE_WINGS, deleteWings);

    // Flats
    yield takeLatest(types.SOCIETY_FLATS_LIST, getFlatsList);
    yield takeLatest(types.SOCIETY_CREATE_FLATS, createFlats);
    yield takeLatest(types.SOCIETY_EDIT_FLATS, editFlats);
    yield takeLatest(types.SOCIETY_DELETE_FLATS, deleteFlats);

    // Dropdowns
    yield takeLatest(types.SOCIETY_WINGS_DROPDOWN, getWingsDropdown);
    yield takeLatest(types.SOCIETY_FLATS_DROPDOWN, getFlatsDropdown);

    // Flats with Ownership
    yield takeLatest(types.SOCIETY_FLATS_WITH_OWNERSHIP, getFlatsWithOwnership);

    // Bulk Uploads
    yield takeLatest(types.SOCIETY_BULK_UPLOAD_WINGS, bulkUploadWings);
    yield takeLatest(types.SOCIETY_BULK_UPLOAD_FLATS, bulkUploadFlats);
}
